import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'atn-datagrid-filters',
  templateUrl: './datagrid-filters.component.html',
  styleUrls: ['./datagrid-filters.component.scss']
})
export class DatagridFiltersComponent implements OnInit {
  ngOnInit() {}
}


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/datagrid/datagrid-filters/datagrid-filters.component.ts